import React, { Fragment } from "react";
import { Loading } from "./Loading";
import axios from "axios";

import { connect } from "react-redux";
import {createUser, loadStatus, logOutUser} from "../actions/postAction";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import LoadingBar from "react-top-loading-bar";

import Moment from "react-moment";
import moment from "moment";
import "moment-timezone";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { BASE_URL } from "../constant";
import Loader from "react-loader-spinner";
import SimpleReactValidator from "simple-react-validator";
import { NetworkError } from "./NetworkError";
import {endpoints, http} from "../configs/https";

class Tahrik_jadid extends React.Component {
  constructor() {
    super();
    this.state = {
      no_of_khuddam_contribution: 0,
      collection_tahrik: 0,
      update_tahrik_magazine: "",
      update_review_magazine: "",
      phone: "",
      returned_no_of_khuddam_contribution: 0,
      returned_collection_tahrik: 0,
      returned_update_tahrik_magazine: "",
      returned_update_review_magazine: "",
      returned_phone: "",
      submitted_by: "",
      isSubmitting: false,
      submitted: false,
      loading: true,
      dateof: "",

      month: 0,

      modal: false,
      networkError: false
    };

    this.toggle = this.toggle.bind(this);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  componentDidMount() {
    document.title = "TAHRIK JADID - MKAN REPORT";
    this.setupValidator();
  }

  setupValidator() {
    this.setState({
      loading: false
    });
    const { year, month } = this.props.monthYear;
    const {failed} = this.props.status;
    if (failed){
      this.props.loadStatus(month,year);
    }
    this.validator = new SimpleReactValidator();
  }

  month_name(dt) {
    var mlist = [
      "",
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    return mlist[dt];
  }

  checkStatus() {
    const { month, year } = this.props.monthYear;
    axios
      .post(
        BASE_URL + `status/`,
        { month: month, year: year },
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(res => {
        if (res.data.tahrik) {
          this.setState({
            submitted: res.data.tahrik,
            loading: false
          });
        }
        this.setState({
          loading: false
        });
      })
      .catch(error => {
        if (error.message === "Network Error") {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          });
          this.setState({
            networkError: true
          });

          Toast.fire({
            type: "warning",
            title:
              "Network error, try Reloading page. Possibly no internet connection "
          });
        } else {
          if (error.response.status === 401) {
            this.props.logOutUser();
            window.location.replace("/");
            this.setState({});
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            });

            Toast.fire({
              type: "error",
              title: "You need to log in again "
            });
          } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            });

            Toast.fire({
              type: "error",
              title: "Something went wrong, try again."
            });
          }
        }
      });
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  }
  handleSubmit(event) {
    event.preventDefault();
    const { month, year } = this.props.monthYear;
    if (!this.validator.allValid()) {
      this.validator.showMessages();

      this.forceUpdate();
      return;
    }

    if (this.state.phone.length > 11) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000
      });

      Toast.fire({
        type: "warning",
        title: "Nazim's phone number should not be greater than 11 characters"
      });
      return;
    }
    Swal.fire({
      title:
        "Are you sure you want to submit your Tahrik Jadid report for " +
        this.month_name(month) +
        " " +
        year +
        "?",
      text:
        "You won't be able to revert this after submitting, kindly check all details are accurate.",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Submit",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33"
    }).then(result => {
      if (result.value) {
        this.setState({
          isSubmitting: true
        });
        console.log(result);

        this.LoadingBar.continousStart();

        http
          .post(
            endpoints.TAHRIK,
            {
              no_khudam_contribution: this.state.no_of_khuddam_contribution,
              collection_tahrik: this.state.collection_tahrik,
              update_tahrik_magazine: this.state.update_tahrik_magazine,
              update_review_magazine: this.state.update_review_magazine,

              phone: this.state.phone,
              month: month,
              year: year
            },
          )
          .then(res => {
            if (res.status !== 201) {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "warning",
                title: "There is an error in your submission, try again"
              });
              this.setState({
                isSubmitting: false
              });
              this.LoadingBar.complete();
            } else {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "success",
                title: "Tahrik Jadid report submitted successfully "
              });

              this.LoadingBar.complete();
              this.setState({
                no_of_khuddam_contribution: 0,
                collection_tahrik: 0,
                update_tahrik_magazine: "",
                update_review_magazine: "",
                phone: "",
                returned_no_of_khuddam_contribution:
                  res.data.no_of_khudam_contribution,
                returned_collection_tahrik: res.data.collection_tahrik,
                returned_update_tahrik_magazine:
                  res.data.update_tahrik_magazine,
                returned_update_review_magazine:
                  res.data.update_review_magazine,
                dateof: res.data.date,

                month: res.data.month,
                submitted_by: res.data.submitted_by,
                isSubmitting: false,

                returned_phone: res.data.phone,
                modal: true
              });
              this.props.loadStatus(month,year);
            }
          })
            .catch(error => {
              this.setState({
                isSubmitting: false
              });
              this.LoadingBar.complete();
              let errorMessage =
                  (typeof error === "string" && error) ||
                  "An error occured, please try again in a moment.";

              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "error",
                title: errorMessage
              });
              // alert(JSON.stringify(error));
              console.log(errorMessage);
            });
      }
    });
  }
  render() {
    const { year, monthName } = this.props.monthYear;
    const {data, isFetching, failed} = this.props.status;
    const {isSubmitting} = this.state;
    return (
      <div>
        {this.state.networkError || failed ? (
          <NetworkError />
        ) : (
          <section className="content">
            {this.state.loading|| isFetching ? (
              <div>
                <div className="spinner">
                  <Loader
                    type="ThreeDots"
                    color="#00BFFF"
                    height="40"
                    width="40"
                  />
                </div>
              </div>
            ) : (
              <div>
                {!data.tahrik ? (
                  <div>
                    <LoadingBar onRef={ref => (this.LoadingBar = ref)} />
                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-header card-header-primary">
                            <h4 className="card-title">
                              TAHRIK JADID (NEW SCHEME) -{" "}
                              {monthName}, {year}
                            </h4>
                            <p className="card-category">
                              Complete the form below
                            </p>
                          </div>
                          <div className="card-body">
                            <form onSubmit={this.handleSubmit}>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      No. of Khuddam contribution in Tahrik –e-
                                      Jadid (List of Such Khuddam must be sent
                                      alongside with the Annual Report )
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      id="no_of_khuddam_contribution"
                                      name="no_of_khuddam_contribution"
                                      value={
                                        this.state.no_of_khuddam_contribution
                                      }
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Collections of Tahrik –e-Jadid Chanda
                                      during the month{" "}
                                    </label>

                                    <input
                                      type="number"
                                      className="form-control"
                                      min="0"
                                      name="collection_tahrik"
                                      value={this.state.collection_tahrik}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Update on Tahrik-Jadid magazines for the
                                      month
                                    </label>
                                    <textarea
                                      className="form-control"
                                      id="update_tahrik_magazine"
                                      name="update_tahrik_magazine"
                                      onChange={this.handleChange}
                                      value={this.state.update_tahrik_magazine}
                                      rows="5"
                                    />
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "magazine",
                                      this.state.update_tahrik_magazine,
                                      "required|min:5|max:500"
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <div className="form-group">
                                      <label className="bmd-label-floating">
                                        {" "}
                                        Update on Review of Religion magazine
                                        for the month{" "}
                                      </label>
                                      <textarea
                                        className="form-control"
                                        id="update_review_magazine"
                                        name="update_review_magazine"
                                        onChange={this.handleChange}
                                        value={
                                          this.state.update_review_magazine
                                        }
                                        rows="5"
                                      />
                                    </div>
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "ror",
                                      this.state.update_review_magazine,
                                      "required|min:5|max:500"
                                    )}
                                  </span>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Nazim Tahrik-e-jadid’s Phone Number{" "}
                                    </label>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id="nazim_tajnid_phone_number"
                                      name="phone"
                                      value={this.state.phone}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "nazim Tahrik-e-jadid’s  phone number",
                                      this.state.phone,
                                      "required|min:5|max:11"
                                    )}
                                  </span>
                                </div>
                              </div>

                              {isSubmitting ? <Loading /> : ""}

                              <button
                                type="submit"
                                className="btn btn-success pull-right"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? "Loading..." : "Submit"}
                              </button>
                              <div className="clearfix" />
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      {/* <Button color="danger" onClick={this.toggle}>{this.props.buttonLabel}</Button> */}
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <h2>
                      You already submitted TAHRIQ JADID report for{" "}
                      <b>
                        {monthName}, {year}
                      </b>
                    </h2>
                  </div>
                )}
              </div>
            )}
            <Modal
              isOpen={this.state.modal}
              toggle={this.toggle}
              className={this.props.className}
            >
              <ModalHeader toggle={this.toggle}>
                Report submission status
              </ModalHeader>
              <ModalBody>
                <p>
                  Submitted By : {this.state.submitted_by}
                  <br />
                  Month :{" "}
                  {moment()
                    .month(this.state.month - 1)
                    .format("MMMM")}
                  <br />
                  Date of Submission : <Moment date={this.state.dateof} />
                  <br />
                  Number of Khuddam Contribution:{" "}
                  {this.state.returned_no_of_khuddam_contribution}
                  <br />
                  Collection of tahrik : {this.state.returned_collection_tahrik}
                  <br />
                  Update on magazine:{" "}
                  {this.state.returned_update_tahrik_magazine}
                  <br />
                  Update on review of religion:{" "}
                  {this.state.returned_update_review_magazine}
                  <br />
                  Nazim's Phone : {this.state.returned_phone}
                </p>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.toggle}>
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          </section>
        )}
      </div>
    );
  }
}

Tahrik_jadid.propTypes = {
  createUser: PropTypes.func.isRequired,
  logOutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  user: state.person.user,
  isLoggedIn: state.person.isLoggedIn,
  monthYear: state.currentMonth.monthYear,
  status: state.status
});

export default connect(mapStateToProps, { createUser, logOutUser ,loadStatus})(
  Tahrik_jadid
);
